import { RumErrorEvent, datadogRum } from '@datadog/browser-rum-slim'

import { CustomRumContext, ModifiedRumEvent } from './types'

const nonCriticalThirdPartyErrorDomains = [
  'https://insights-api.ramp.com',
  'https://api.amplitude.com',
  'https://r.lr-ingest.io',
  'https://stats.g.doubleclick.net',
]

/**
 * @param event - Datadog RUM event
 *
 * @see https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#enrich-and-control-rum-data
 */
export const beforeSend = (event: ModifiedRumEvent) => {
  if (isRumErrorEvent(event)) {
    return filterNonCriticalThirdPartyErrors(event)
  }

  removeDatadogRumGlobalContext('is_full_page_crash')
}

const isRumErrorEvent = (event: ModifiedRumEvent): event is RumErrorEvent => event.type === 'error'

/**
 * @see https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#discard-a-rum-event
 */
const filterNonCriticalThirdPartyErrors = (event: RumErrorEvent): boolean => {
  const { resource } = event.error

  if (!resource) {
    return true
  }

  return !nonCriticalThirdPartyErrorDomains.some((domain) => resource.url.startsWith(domain))
}

/**
 * Adds the key-value pair to Datadog's global context.
 *
 * @see https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#add-global-context
 */
export const addDatadogRumGlobalContext = <TKey extends keyof CustomRumContext>(
  key: TKey,
  value: Required<CustomRumContext>[TKey]
) => {
  datadogRum.addRumGlobalContext(key, value)
}

export const removeDatadogRumGlobalContext = (key: keyof CustomRumContext) => {
  datadogRum.removeRumGlobalContext(key)
}
